export const AppRoutesConst = Object.freeze({
    // public
    login: 'login',
    register: 'register',
    caseReport: 'case-report',
    dischargeSummary:'discharge-summary',
    clinicalNote:'clinical-note',
    generateClinicalNote:'generate-clinical-note',
    searchTreatment: 'search-treatment',
    drugDosage: 'drug-dosage-research',
    resources: 'resources',
    membership: 'membership',
    contactUs: 'contact-us',
    contributors: 'contributors',
    medboxbot:'chatmed',
    privacyPolicy: 'privacy-policy',
    auth:'auth',
    profile : 'profile',
    termsCondition: 'terms-and-conditions',
    clinicalDecisionAssistant: 'clinical-decision-assistant',
} as const);



